/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 意欲（転職意欲・副業意欲）に関するフラグ
 * @export
 * @interface GetAccount200ResponseFeatureFlagsIntention
 */
export interface GetAccount200ResponseFeatureFlagsIntention {
    /**
     * 表示有無 true:表示 false:非表示
     * @type {boolean}
     * @memberof GetAccount200ResponseFeatureFlagsIntention
     */
    visible: boolean;
}

/**
 * Check if a given object implements the GetAccount200ResponseFeatureFlagsIntention interface.
 */
export function instanceOfGetAccount200ResponseFeatureFlagsIntention(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "visible" in value;

    return isInstance;
}

export function GetAccount200ResponseFeatureFlagsIntentionFromJSON(json: any): GetAccount200ResponseFeatureFlagsIntention {
    return GetAccount200ResponseFeatureFlagsIntentionFromJSONTyped(json, false);
}

export function GetAccount200ResponseFeatureFlagsIntentionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccount200ResponseFeatureFlagsIntention {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'visible': json['visible'],
    };
}

export function GetAccount200ResponseFeatureFlagsIntentionToJSON(value?: GetAccount200ResponseFeatureFlagsIntention | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'visible': value.visible,
    };
}

